export default "__VITE_ASSET__HoCPW2sh__"